export const DEFAULT_REGION_NOMBRE = 'Región de Los Lagos';
export const DEFAULT_COMUNA_NOMBRE = 'Osorno';
